<template>
  <div class="home-wrapper">
    <div class="home-search">
      <div class="search-style">
        <div class="icon-search"></div>
        <div class="input-box">
          <input
            type="text"
            v-model="businessName"
            class="input-container"
            placeholder="请输入机构名称"
          />
        </div>
        <div class="search-btn" @click="searchClick">搜索</div>
      </div>
    </div>
    <div class="home-container">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :offset="100"
          :finished="finished"
          :finished-text="pageList[0] ? '没有更多了' : '暂无数据'"
          @load="onLoad"
        >
          <div
            class="org-item"
            v-for="(org, i) in pageList"
            :key="i"
            @click="handleClick(org)"
          >
            <div class="img-box">
              <img
                v-if="org.businessImage"
                :src="org.businessImage"
                class="img-have"
                alt=""
              />
              <img
                v-else
                class="img-null"
                src="@/assets/photo_fill.png"
                alt=""
              />
            </div>
            <div class="right-view">
              <div class="org-title">
                <span>{{ org.businessName }}</span>
                <span v-if="org.branchName" class="branch-name">({{org.branchName}})</span>
                <!-- <p class="sign-box">
                  <span class="isSign">签约</span>
                </p> -->
              </div>
              <div class="org-tel">
                <i class="tel-icon"></i>
                <span>{{ org.phone }}</span>
              </div>
              <div class="org-adress">
                <i class="adress-icon"></i>
                <span>{{ org.address }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
const baseUrl = process.env.NODE_ENV === "production" ? "/app" : "/api";
import formatDate from "@/filters/formatDate";
import { getOrglist } from "@/api/attest";

export default {
  components: {},
  data() {
    return {
      businessName: "",
      loading: false,
      isLoading: false,
      finished: false,
      pageList: [],
    };
  },
  methods: {
    searchClick() {
      this.onRefresh();
    },
    handleClick(org) {
      this.$router.push({
        path: "/orginfo",
        query: {
          bid: org.id,
          branchId:org.branchId,
          areaName:this.$route.query.areaName
        },
      });
    },
    onLoad() {
      if (this.page === 1) {
        return;
      } else {
        this.loading = true;
        this.getList();
      }
    },
    onRefresh() {
      this.page = 1;
      this.pageList = [];
      this.finished = false;
      this.loading = true;
      this.getList();
    },
    getList() {
      getOrglist({
        businessName: this.businessName,
        pageIndex: this.page,
        areaName: this.$route.query.areaName,
        id: this.$route.query.id,
        t: this.$route.query.t,
        sign: this.$route.query.sign,
      })
        .then((res) => {
          console.log(res.data);

          this.loading = false;
          this.isLoading = false;

          if (res.data.records.length < 10) {
            this.finished = true;
          } else {
            this.page++;
          }
          this.pageList = this.pageList.concat(res.data.records);
        })
        .catch(() => {
          console.log("haha");
        });
    },
  },
  mounted() {
    this.onRefresh();
  },
};
</script>
<style lang="less" scoped>
.home-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  padding-top: 80px;
  .home-search {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 375px;
    background-color: #fff;
    padding: 21px 15px 10px;
    .search-style {
      position: relative;
      width: 346px;
      height: 36px;
      border: 1px solid #1779ff;
      border-radius: 18px;
      .icon-search {
        position: absolute;
        left: 14px;
        top: 10px;
        width: 16px;
        height: 16px;
        background: url("../../assets/search.png") no-repeat center;
        background-size: 100% 100%;
      }
      .input-box {
        position: relative;
        height: 36px;
        padding-left: 38px;
        padding-right: 60px;
      }
      .input-container {
        position: absolute;
        top: 0px;
        height: 36px;
        font-size: 16px;
        background: transparent;
        text-indent: 8px;
        &::placeholder {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #a5a5a5;
        }
      }
      .search-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 60px;
        height: 34px;
        background: linear-gradient(90deg, #1779ff, #4996ff);
        border-radius: 17px;
        font-size: 16px;
        line-height: 34px;
        text-align: center;
        color: #fff;
      }
    }
  }

  .home-container {
    height: auto;
    padding-left: 14px;
    padding-right: 15px;
    padding-top: 10px;
    background-color: #f5f5f5;
    .sign-box{
      display: inline-block;
      height: 17px;
      margin-left: 6px;
      position: relative;
    }
    .isSign {
      position: absolute;
      top: 4px;
      left: 0;
      display: inline-block;
      width: 31px;
      height: 15px;
      background: linear-gradient(90deg, #1779ff, #4996ff);
      border-radius: 2px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 15px;
      text-align: center;
    }
    .org-item {
      position: relative;
      width: 346px;
      height: 146px;
      background: #ffffff;
      border-radius: 7px;
      margin-bottom: 12px;
      padding: 12px 14px 12px 8px;
    }

    .img-box {
      width: 120px;
      height: 120px;
      background: #ededed;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      .img-have {
        position: absolute;
        top: 0;
        left: 0;
        width: 120px;
        height: 120px;
      }
      .img-null {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 31px;
      }
    }
    .right-view {
      position: absolute;
      top: 8px;
      right: 14px;
      width: 207px;
      height: 117px;
      padding-left: 13px;
      .org-title {
        width: 100%;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #121212;
        line-height: 22px;
        word-break: break-all;
        margin-bottom: 6px;
      }
      .branch-name{
        font-size:14px
      }
      .org-tel {
        display: flex;
        align-items: center;
        width: 100%;
        height: 12px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #121212;
        line-height: 20px;
        margin-bottom: 6px;
        .tel-icon {
          display: inline-block;
          width: 11px;
          height: 11px;
          background: url("../../assets/tel.png") no-repeat center;
          background-size: 9px 11px;
          margin-right: 5px;
        }
      }
      .org-adress {
        width: 100%;
        height: 16px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #767676;
        line-height: 16px;
        word-break: break-all;
        .adress-icon {
          display: inline-block;
          width: 10px;
          height: 16px;
          background: url("../../assets/adress.png") no-repeat center;
          background-size: 10px 12px;
          background-position: 0 5px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
